import React, { ChangeEvent, Fragment, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import ImageSelector from '../../../components/ImageSelectorFeatured'
import { InputField } from '../../../components/InputField'
import { BASE_URL_API_DE_NEW, GO_DE_GQL_BACKEND_URL, } from '../../../constants'
import { useApi } from '../../../contexts/ApiContext'
import { useAuth } from '../../../contexts/AuthContext'
import { FetchApi } from '../../../api/fetch'

export function ManageNFTPartner({ getCommunity, hide, partner }: any) {
   const initialData = {
      collection_name: partner?.collectionName ?? "",
      number_of_spots: partner?.numberOfSpots ?? 0,
      collection_id: partner?.collectionId ?? "",
      image: partner?.image ?? "",
      position: partner?.position ?? 1,
      total_allocations: partner?.totalAllocations ?? 0,
   }
   const [featured, setFeatured] = useState(initialData)
   const [thumbnail, setThumbnail] = useState<string>()
   const [thumbnailFile, setThumbnailFile] = useState()
   const [featuredName, setFeaturedName] = useState('')
   const [searchItems, setSearchItems] = useState<any[]>([])
   const [showList, setShowList] = useState<boolean>(false)


   const { uploadFile } = useApi()
   const { setIsLoadingOverlayDisplay } = useAuth()

   useEffect(() => {
      searchCollectionsSolana()
   }, [featured?.collection_name])


   const onSelectThumbnail = () => {
      setTimeout(() => {
         document?.getElementById("thumbnailSelector")?.click()
      }, 0)
   }

   const handleFeaturedThumbnailSelected = (event: any) => {
      const reader = new FileReader()
      const file = event?.target?.files && event?.target?.files[0]
      if (file) {
         setThumbnailFile(file)
         reader.onloadend = () => {
            setThumbnail(reader?.result as string)
            setFeaturedName(
               file.name
            )
         }
         reader.readAsDataURL(file as Blob)
      }
   }

   const handleChange = (e: any) => {
      const { target } = e;
      setFeatured({ ...featured, [target.name]: target.value })
   }

   const searchCollectionsSolana = async () => {
      const val = featured?.collection_name + '%';
      const collectionsPromise = await FetchApi({
         endpoint: `${GO_DE_GQL_BACKEND_URL}`,
         method: "POST",
         body: ({
            query: `
             query MyQuery($name: String) {
               collections(name: $name) {
                 nodes {
                   name
                   id
                 }
               }
           }`,
            variables: { name: val }
         })
      })
         .catch((err) => console.log(err))
      setSearchItems(collectionsPromise?.data?.collections?.nodes)
   }

   const saveFeatured = async (e: any) => {
      e.preventDefault()

      setIsLoadingOverlayDisplay(true)
      const userJWT = JSON.parse(sessionStorage.getItem('userData') || '{}').token

      if (thumbnailFile) {
         await uploadFile(
            thumbnailFile,
         )
      }

      const url = featuredName ? "https://creator-portal-bucket.s3.us-east-2.amazonaws.com/" + featuredName : initialData.image

      try {
         let response: any = await FetchApi({
            endpoint: `${BASE_URL_API_DE_NEW}v2/user/add-whitelist-partner`,
            method: "POST",
            JWT: userJWT,
            body: ({ ...featured, image: url, number_of_spots: +featured.number_of_spots })
         })

         response = await response.json()
         if (response.success) {
            hide()
            getCommunity()
         }
      } catch (error) {
         setIsLoadingOverlayDisplay(false)
      }

      setIsLoadingOverlayDisplay(false)
   }


   return (
      <div className='m-auto my-10 min-w-[800px]'>
         <div className="mt-0 mb-12 flex flex-row justify-between items-center sm:flex-row">
            <h1 className="font-semibold text-2xl text-center">
               NFT Whitelist Partner
            </h1>
         </div>
         <form onSubmit={saveFeatured}>
            <div className="flex gap-8 mb-8">
               <div className="w-6/12 text-left">

                  <InputField
                     label="Collection Name"
                     name='collection_name'
                     type='text'
                     value={featured?.collection_name}
                     onChange={(e) => {
                        handleChange(e)
                        if (!showList) {
                           setShowList(true)
                        }
                     }}
                     readOnly={!!partner}
                     required
                  />

                  {
                     (showList && featured?.collection_name?.length > 1) &&
                     <Fragment>
                        <div className="items flex flex-col absolute z-50 bg-gray-900 rounded-md p-4 max-h-[300px] overflow-y-auto overflow-x-hidden">
                           {
                              searchItems?.map((collection: any) => (
                                 <div
                                    key={collection.id}
                                    onClick={() => {
                                       setShowList(false)
                                       setFeatured({ ...featured, collection_id: collection.id, collection_name: collection.name });
                                    }}
                                    className="border-2 rounded-md bg-gray-900 w-[350px] border-gray-800 md:shadow-lg p-4 flex flex-row mb-4 justify-between cursor-pointer"
                                 >
                                    <h4 className="uppercase font-bold text-xl">{collection.name}</h4>
                                 </div>
                              ))
                           }
                        </div>
                     </Fragment>
                  }
                  <InputField
                     label="Number of Spots"
                     name='number_of_spots'
                     type='number'
                     min={initialData.total_allocations}
                     value={featured.number_of_spots}
                     onChange={handleChange}
                     required
                  />
                  <InputField
                     label="Collection Id"
                     name='collection_id'
                     type='text'
                     value={featured.collection_id}
                     onChange={handleChange}
                     readOnly={!!partner}
                     required
                  />
               </div>
               <div className="w-6/12">
                  <input
                     style={{ display: "none" }}
                     type="file"
                     accept=".png, .jpg, .jpeg, .gif"
                     id="thumbnailSelector"
                     onChange={handleFeaturedThumbnailSelected}
                  />
                  <ImageSelector
                     iconSrc={thumbnail || initialData.image}
                     onSelectIcon={onSelectThumbnail}
                  />
               </div>
            </div>
            <div>
               <button type="submit" className="btn_gradient w-full">Save</button>
            </div>
         </form>
      </div>
   )
}


export function ManageTokenPartner({ getCommunity, hide, partner }: any) {
   const initialData = {
      token_name: partner?.tokenName ?? "",
      number_of_spots: partner?.numberOfSpots ?? 0,
      token_id: partner?.tokenId ?? "",
      image: partner?.image ?? "",
      position: partner?.position ?? 1,
      eligibility_csv_url: partner?.eligibilityCsvUrl,
      total_allocations: partner?.totalAllocations,
   }
   const [featured, setFeatured] = useState(initialData)
   const [thumbnail, setThumbnail] = useState<string>()
   const [thumbnailFile, setThumbnailFile] = useState<File | null>()
   const [csvFile, setCsvFile] = useState<File | null>()
   const [searchItems, setSearchItems] = useState<any[]>([])
   const [showList, setShowList] = useState<boolean>(false)


   const { uploadFile } = useApi()
   const { setIsLoadingOverlayDisplay } = useAuth()

   useEffect(() => {
      searchCollectionsSolana()
   }, [featured?.token_name])


   const onSelectThumbnail = () => {
      setTimeout(() => {
         document?.getElementById("thumbnailSelector")?.click()
      }, 0)
   }

   const handleFeaturedThumbnailSelected = (event: any) => {
      const reader = new FileReader()
      const file = event?.target?.files && event?.target?.files[0]
      if (file) {
         setThumbnailFile(file)
         reader.onloadend = () => {
            setThumbnail(reader?.result as string)
         }
         reader.readAsDataURL(file as Blob)
      }
   }

   const handleChange = (e: any) => {
      const { target } = e;
      setFeatured({ ...featured, [target.name]: target.value })
   }

   const searchCollectionsSolana = async () => {
      const val = '%' + featured?.token_name + '%';
      const collectionsPromise = await FetchApi({
         endpoint: `${GO_DE_GQL_BACKEND_URL}`,
         method: "POST",
         body: {
            query: `
             query MyQuery($name: String, $limit: Int, $offset: Int,) {
               token(name: $name, limit: $limit, offset: $offset) {
                 nodes {
                   name
                   id
                 }
               }
           }`,
            variables: { name: val, limit: 50, offset: 0 }
         }
      }).then((res) => res.json())
         .catch((err) => console.log(err))
      setSearchItems(collectionsPromise?.data?.token?.nodes)
   }

   const saveFeatured = async (e: any) => {
      e.preventDefault()

      setIsLoadingOverlayDisplay(true)
      const userJWT = JSON.parse(sessionStorage.getItem('userData') || '{}').token

      if (thumbnailFile) {
         await uploadFile(thumbnailFile)
      }

      if (csvFile) {
         await uploadFile(csvFile)
      }

      const imageUrl = thumbnailFile?.name ? "https://creator-portal-bucket.s3.us-east-2.amazonaws.com/" + thumbnailFile?.name : initialData.image
      const csvUrl = csvFile?.name ? "https://creator-portal-bucket.s3.us-east-2.amazonaws.com/" + csvFile?.name : initialData.eligibility_csv_url

      try {
         let response: any = await FetchApi({
            endpoint: `${BASE_URL_API_DE_NEW}v2/user/${partner ? `update-token-whitelist-partner/${partner.id}` : 'add-token-whitelist-partner'}`,
            method: partner ? "PUT" : "POST",
            JWT: userJWT,
            body: { ...featured, image: imageUrl, eligibility_csv_url: csvUrl, number_of_spots: +featured.number_of_spots }
         })

         response = await response.json()
         if (response.success) {
            hide()
            getCommunity()
         }
         else {
            toast.error(response.message)
         }

      } catch (error) {
         setIsLoadingOverlayDisplay(false)
         console.log('something went wrong', error);
      }

      setIsLoadingOverlayDisplay(false)
   }


   return (
      <div className='m-auto my-10 min-w-[800px]'>
         <div className="mt-0 mb-12 flex flex-row justify-between items-center sm:flex-row">
            <h1 className="font-semibold text-2xl text-center">
               Token Whitelist Partner
            </h1>
         </div>
         <form onSubmit={saveFeatured}>
            <div className="flex gap-8 mb-8">
               <div className="w-6/12 text-left">

                  <InputField
                     label="Token Name"
                     name='token_name'
                     type='text'
                     value={featured?.token_name}
                     onChange={(e) => {
                        handleChange(e)
                        if (!showList) {
                           setShowList(true)
                        }
                     }}
                     readOnly={!!partner}
                     required
                  />

                  {
                     (showList && featured?.token_name?.length > 1) &&
                     <Fragment>
                        <div className="items flex flex-col absolute z-50 bg-gray-900 rounded-md p-4 max-h-[300px] overflow-y-auto overflow-x-hidden">
                           {
                              searchItems?.map((tkn: any) => (
                                 <div
                                    key={tkn.id}
                                    onClick={() => {
                                       setShowList(false)
                                       setFeatured({ ...featured, token_id: tkn.id, token_name: tkn.name });
                                    }}
                                    className="border-2 rounded-md bg-gray-900 w-[350px] border-gray-800 md:shadow-lg p-4 flex flex-row mb-4 justify-between cursor-pointer"
                                 >
                                    <h4 className="uppercase font-bold text-xl">{tkn.name}</h4>
                                 </div>
                              ))
                           }
                        </div>
                     </Fragment>
                  }
                  <InputField
                     label="Number of Spots"
                     name='number_of_spots'
                     type='number'
                     min={initialData.total_allocations}
                     value={featured.number_of_spots}
                     onChange={handleChange}
                     required
                  />
                  {
                     initialData.eligibility_csv_url &&
                     <p>Selected CSV :  <a href={initialData.eligibility_csv_url} download={`${featured.token_name}.pdf`}>Download File</a></p>
                  }
                  <InputField
                     label="CSV file"
                     name='eligibility_csv_url'
                     type='file'
                     accept=".csv,text/csv"
                     onChange={(e: ChangeEvent<HTMLInputElement>) => {
                        setCsvFile(e.target.files?.[0])
                     }}

                  />
                  <InputField
                     label="Token Id"
                     name='token_id'
                     type='text'
                     value={featured.token_id}
                     onChange={handleChange}
                     readOnly={!!partner}
                     required
                  />
               </div>
               <div className="w-6/12">
                  <input
                     style={{ display: "none" }}
                     type="file"
                     accept=".png, .jpg, .jpeg, .gif"
                     id="thumbnailSelector"
                     onChange={handleFeaturedThumbnailSelected}
                  />
                  <ImageSelector
                     iconSrc={thumbnail || initialData.image}
                     onSelectIcon={onSelectThumbnail}
                  />
               </div>
            </div>
            <div>
               <button type="submit" className="btn_gradient w-full">Save</button>
            </div>
         </form>
      </div>
   )
}